import React from 'react';
import blueTickCircle from '../../../images/blueTickCircle.svg';
import Input from '../../../components/VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm';
import useTranslation from '../../../hooks/use-translation';

import './thankYou.css'

const ThankYou = ({ response, hide_back, source_id, iframeSrc }) => {
  const { t } = useTranslation();

  return (
    <div className="thank-you-page">
      <img className="blue-tick-circle" src={blueTickCircle} alt="blue-tick-circle" />
      <div className="thank-you">
        {t("EOI_THANK_YOU")}
      </div>
      {response === "Yes" &&
        <div className="thank-you-text" dangerouslySetInnerHTML={{ __html: t("THANK_YOU_MESSAGE_YES_SELECTED") }}></div>
      }
      {response === "No" &&
        <div className="thank-you-text" dangerouslySetInnerHTML={{ __html: t("THANK_YOU_MESSAGE_NO_SELECTED") }}></div>
      }
      {response === "Vaccinated" &&
        <div className="thank-you-text" dangerouslySetInnerHTML={{ __html: t("THANK_YOU_MESSAGE_ALREADY_VACCINATED") }}></div>
      }
      {
        (source_id === "JhhWebApp" || iframeSrc === "JhhWebApp") &&
        (
          response === "Vaccinated" ?
            // <a className="anchor-thank-you-button" href={`upload-vaccination-certificate://healthhub.jio.com`}>
            <Input
              type="button"
              addClassInput="thank-you-button"
              value={t("UPLOAD_CERTIFICATE_MESSAGE")}
              onClick={(e) => { window.parent.postMessage("vaccinated", "*") }}
            />
            // </a>
            :
            // <a className="anchor-thank-you-button" href={`vaccination-dashboard://healthhub.jio.com`}>
            <Input
              type="button"
              addClassInput="thank-you-button"
              value={t("GO_TO_DASHBOARD")}
              onClick={(e) => { window.parent.postMessage("YesNo", "*") }}
            />
          // </a>
        )
      }
      {
        (source_id === "JioHealthHub" && iframeSrc !== "JhhWebApp") &&
        (
          response === "Vaccinated" ?
            <a className="anchor-thank-you-button" href={`upload-vaccination-certificate://healthhub.jio.com`}>
              <Input
                type="button"
                addClassInput="thank-you-button"
                value={t("UPLOAD_CERTIFICATE_MESSAGE")}
              />
            </a>
            :
            <a className="anchor-thank-you-button" href={`vaccination-dashboard://healthhub.jio.com`}>
              <Input
                type="button"
                addClassInput="thank-you-button"
                value={t("GO_TO_DASHBOARD")}
              />
            </a>
        )
      }
    </div>
  );
};

export default ThankYou;